import { render, staticRenderFns } from "./MemberManagementAssignments.vue?vue&type=template&id=9cffa31e"
import script from "./MemberManagementAssignments.vue?vue&type=script&lang=js"
export * from "./MemberManagementAssignments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports